import { render, staticRenderFns } from "./contactData.vue?vue&type=template&id=5861004c&scoped=true"
import script from "./contactData.vue?vue&type=script&lang=js"
export * from "./contactData.vue?vue&type=script&lang=js"
import style0 from "./contactData.vue?vue&type=style&index=0&id=5861004c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861004c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5861004c')) {
      api.createRecord('5861004c', component.options)
    } else {
      api.reload('5861004c', component.options)
    }
    module.hot.accept("./contactData.vue?vue&type=template&id=5861004c&scoped=true", function () {
      api.rerender('5861004c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/base/components/form/steps/contactData.vue"
export default component.exports